class QuickAddDrawer extends window.BAO.CustomElement() {
  setupListeners() {
    super.setupListeners()

    this.externalEls.open?.elements.forEach((el) => {
      this.listeners.add(el, 'click', () => {
        const productUrl = el.dataset.productUrl

        if (!productUrl) return

        this.openModal(productUrl)

      })
    })

    this.listeners.add(this.els.close?.element, 'click', () => this.els.modal?.element.close())
  }

  async openModal(url) {
    const detailsTarget = this.els.details?.element

    if (!detailsTarget) return

    detailsTarget.innerHTML = ''

    try {
      const request = await fetch(`${url}?section_id=bao-quick-add`)
      const responseText = await request.text()
      const responseHtml = new DOMParser().parseFromString(responseText, 'text/html')

      const detailsSource = responseHtml.querySelector('[data-quick-add-drawer-el="details"]')

      if (detailsSource) {
        detailsTarget.innerHTML = detailsSource.innerHTML
      }

      this.els.modal.element.showModal()
    } catch (error) {
      console.error(error)
    }
  }
}

if (!customElements.get('quick-add-drawer')) {
  customElements.define('quick-add-drawer', QuickAddDrawer)
}

class QuickAddForm extends window.BAO.CustomElement() {
  setupListeners() {
    super.setupListeners()

    this.listeners.add(this.els.radios?.element, 'input', this.updateSelectedVariant.bind(this))

    this.listeners.add(this.els['size-guide-open']?.element, 'click', this.openSizeGuideModal.bind(this))

    this.listeners.add(this.els['size-guide-close']?.element, 'click', this.closeSizeGuideModal.bind(this))

    this.listeners.add(this.els.form?.element, 'submit', (event) => {
      event.preventDefault()
      this.addToCart()
    })
  }

  openSizeGuideModal() {
    this.els['size-guide-modal']?.element.showModal()
  }

  closeSizeGuideModal() {
    this.els['size-guide-modal']?.element.close()
  }

  updateSelectedVariant() {
    this.updateOptions();
    this.updateSelectedVariantId();
    this.resetForm();

    if (!this.currentVariant) {
      this.toggleAddButton();
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.els.form?.element.querySelectorAll('[data-quick-add-form-el="option-radio"]:checked,[data-quick-add-form-el="option-input"]'),
      (select) => select.value.trim()
    );
  }

  updateSelectedVariantId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const idInput = this.els.form?.element.querySelector('[data-quick-add-form-el="id"]');
    idInput.value = this.currentVariant.id;
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  resetForm() {
    if (this.els.error?.element) this.els.error.element.textContent = ''
    this.els.error?.element.setAttribute('hidden', 'true')

    if (this.els.add.element && this.els.add.element.hasAttribute("aria-disabled")) {
      this.els.add.element.removeAttribute("aria-disabled");
    }
  }

  renderProductInfo() {
    this.toggleAddButton(!this.currentVariant.available);

    const soldOut = this.els['sold-out']?.element;

    if (this.currentVariant && soldOut) {

      soldOut.toggleAttribute('hidden', this.currentVariant.available);

      const url = new URL(soldOut.href);

      url.searchParams.set('variant', this.currentVariant.id.toString());

      soldOut.href = url.toString()
    }
  }

  toggleAddButton(disable = true, modifyClass = true) {
    if (!this.els.form?.element || !this.els.add?.element) {
      return;
    }

    if (disable) {
      this.els.add?.element.setAttribute("disabled", "disabled");
      this.els.add?.element.setAttribute("hidden", "true");
    } else {
      this.els.add?.element.removeAttribute("disabled");
      this.els.add?.element.removeAttribute("hidden");
      if (this.els.add?.element) this.els.add.element.textContent = this.els.add.element.hasAttribute("data-is-pre-order")
        ? window.variantStrings.preOrder
        : window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    if (!this.els.form?.element || !this.els.add?.element) {
      return;
    }

    this.els.add.element.textContent = addButton.hasAttribute("data-is-coming-soon")
      ? window.variantStrings.comingSoon
      : window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  showError(message) {
    if (this.els.error?.element) this.els.error.element.textContent = message;
    this.els.error?.element.removeAttribute("hidden");
    this.els.error?.element.focus();
  }

  addToCartFirstCallback(requestState) {
    if (this.els.add?.element) this.els.add.element.textContent = window.variantStrings.addToCart;
    this.els.add?.element.removeAttribute("aria-busy");

    if (requestState.responseData.status !== 200) {
      console.error(requestState.responseData.status);
      if (
        requestState.responseData.status === 422 &&
        requestState.responseData.body.message
      ) {
        this.showError(requestState.responseData.body.message);
      }
    }
  }

  addToCart() {
    if (!this.els.form?.element) return

    const formData = new FormData(this.els.form.element)
    const variantId = this.els.id?.element.value

    this.resetForm()

    if (!variantId) {
      this.showError(window.variantStrings.chooseASize);
      return;
    }

    if (this.els.add?.element) this.els.add.element.textContent = window.variantStrings.addingToCart;
    this.els.add?.element.setAttribute("aria-busy", true);

    const options = {
      firstCallback: (requestState) =>
        this.addToCartFirstCallback(requestState),
      important: true,
    };

    this.listeners.add(document, 'liquid-ajax-cart:request-end', (event) => {
      const { requestState } = event.detail;
      if (requestState.requestType === "add" && requestState.responseData?.ok) {
        this.externalEls.modal?.element.close()
      }
    }, { once: true })

    liquidAjaxCart.add(formData, options);

    return;
  }
}

if (!customElements.get('quick-add-form')) {
  customElements.define('quick-add-form', QuickAddForm)
} 